import { useLang } from "../../contexts/LanguageContext";

export function LangToggle({ variant = "header" }) {
  const { lang, setLang } = useLang();
  const base =
    "text-[11px] uppercase tracking-[0.28em] font-medium transition-opacity";
  const active = "text-ink";
  const inactive = "text-stone hover:text-ink";

  return (
    <div
      className="flex items-center gap-2"
      data-testid="lang-toggle"
      aria-label="Language toggle"
    >
      <button
        type="button"
        data-testid="lang-pl"
        onClick={() => setLang("pl")}
        className={`${base} ${lang === "pl" ? active : inactive}`}
      >
        PL
      </button>
      <span className="text-stone/60 text-xs">/</span>
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`${base} ${lang === "en" ? active : inactive}`}
      >
        EN
      </button>
    </div>
  );
}
